import Vue from 'vue'
import VueRouter from 'vue-router'
import axios from 'axios'
import store from '../store'

import { experimentData } from '../data/experiments/experiement.js'
import bus from '../plugins/bus.js'
import { BASE_API_URL } from '../store/api'

Vue.use(VueRouter)

const instance = axios.create({
  // baseURL: BASE_API_URL
  baseURL: 'https://vlab.pusan.ac.kr/backend'
})

const isAuthenticated = (to, from, next) => {
  if (localStorage.getItem('socialState')) {
    localStorage.removeItem('socialState')
    store.commit('auth/deleteToken')
  }
  if (store.getters['auth/isAuth']) {
    instance.defaults.headers.common.Authorization = store.state.auth.access
    instance.post('/users/user-check/', {})
      .then(res => {
        store.dispatch('auth/settingUser')
        if (to.path !== '/main') {
          next({
            name: 'Home'
          })
        } else next()
      }).catch(err => {
        if (err.response.status === 401 && localStorage.getItem('vue-auth-jwt_token')) {
          window.alert('로그인 시간이 만료되었습니다. 다시 로그인 해주세요.')
          store.dispatch('auth/signout')
        }
      })
  } else {
    if (to.path !== '/main') {
      next({
        name: 'Home'
      })
    } else next() // go signup*/
  }
}

const getUser = (to, from, next) => {
  if (store.getters['auth/isAuth']) {
    instance.defaults.headers.common.Authorization = store.state.auth.access
    instance.post('/users/user-check/', {})
      .then(res => {
        store.dispatch('auth/settingUser')
      })
  }
}

const getUserInfo = (to, from, next) => {
  if (router.history.current.fullPath.includes('page')) bus.$emit('start:spinner')
  if (store.getters['auth/isAuth']) {
    instance.defaults.headers.common.Authorization = store.state.auth.access
    instance.post(`/users/user-check/`, {})
      .then(res => {
        store.dispatch('auth/settingUser')
      })
      .catch(err => {
        window.alert('잘못된 접근입니다. 다시 로그인해주세요.', err)
        store.dispatch('auth/signout')
      })
  }
}

const routes = [
  {
    path: '/',
    beforeEnter: isAuthenticated
  },
  {
    path: '/main',
    name: 'Home',
    beforeEnter: getUser(),
    component: () => import('../views/pages/Home.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/auth/Login.vue')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/auth/Register.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/pages/main/About.vue')
  },
  {
    path: '/usage',
    name: 'Usage',
    component: () => import('../views/pages/main/Usage.vue')
  },
  {
    path: '/introduction',
    name: 'Introduction',
    component: () => import('../views/pages/main/Introduction.vue')
  },
  {
    path: '/welcome',
    name: 'Welcome',
    component: () => import('../views/pages/main/Welcome.vue')
  },
  {
    path: '/help',
    name: 'Help',
    component: () => import('../views/pages/main/Help.vue'),
    props: true
  },
  {
    path: '/module-com/page/:id',
    name: 'ModulecomPage',
    component: () => import('../views/pages/main/Modulecom.vue'),
    props: (route) => ({ id: route.params.id, ex: 1 })
  },
  {
    path: '/module-com/ex/:id',
    name: 'Modulecom',
    component: () => import('../views/simulation/micom/SimulationBoard'),
    props: (route) => ({ list: experimentData.data().moduleCom, id: route.params.id }),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/com/page/:id',
    name: 'MicomPage',
    component: () => import('../views/pages/main/Micom.vue'),
    props: (route) => ({ id: route.params.id, ex: 2 })
  },
  {
    path: '/com/ex/:id',
    name: 'Micom',
    component: () => import('../views/simulation/micom/SimulationBoard'),
    props: (route) => ({ list: experimentData.data().micom, id: route.params.id }),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/circuit/page/:id',
    name: 'CircuitPage',
    component: () => import('../views/pages/main/Circuit.vue'),
    props: (route) => ({ id: route.params.id, ex: 3 })
  },
  {
    path: '/board/:id',
    name: 'Board',
    component: () => import('../views/pages/board/Bulletin.vue'),
    props: (route) => ({ id: route.params.id, pname: route.name }),
    children: [
      {
        path: 'editor',
        name: 'Editor',
        component: () => import('../views/pages/board/BoardEditor.vue'),
        props: true,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'contents/:bid',
        name: 'BoardContents',
        component: () => import('../views/pages/board/BoardContents.vue'),
        props: (route) => ({ bid: route.params.bid }),
        children: [
          {
            path: 'editor',
            name: 'ContentsEditor',
            component: () => import('../views/pages/board/ContentsEditor.vue'),
            props: (route) => ({ bid: route.params.bid })
          }
        ]
      }
    ]
  },
  {
    path: '/schedule',
    name: 'Schedule',
    component: () => import('../views/pages/board/Calender.vue'),
    beforeEnter: getUser()
  },
  {
    path: '/popup-video',
    name: 'PopupVideo',
    component: () => import('../views/pages/main/PopupVideo.vue'),
  }
  
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (window.location.href.indexOf("localhost") > -1 || window.location.href.indexOf("127.0.0.1") > -1) {
    console.log('Localhost, Skip user setting.')
    next()
    return
  }
  
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters['auth/isAuth']) {
      next({
        name: 'Login'
      })
      window.alert('로그인이 필요합니다.')
    } else {
      next()
      getUserInfo()
    }
  } else {
    next()
  }
})

export default router
